import { render, staticRenderFns } from "./TaxPph23CodeView.vue?vue&type=template&id=36061de7"
import script from "./TaxPph23CodeView.vue?vue&type=script&lang=js"
export * from "./TaxPph23CodeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports